import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, Sparkles, LogOut } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";

export default function Navbar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();

  const linkCls = (active) =>
    `flex items-center gap-2 px-4 py-2 rounded-full text-sm font-semibold transition-colors ${
      active ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:text-foreground hover:bg-secondary"
    }`;

  const initials = (user?.name || "T")
    .split(" ")
    .map((n) => n[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

  return (
    <header className="sticky top-0 z-50 glass">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
        <Link to="/dashboard" data-testid="nav-brand-logo" className="flex items-center">
          <img src="/logo-light.png" alt="VividVR" className="h-8 w-auto" />
        </Link>

        <nav className="flex items-center gap-1.5">
          <Link to="/dashboard" data-testid="nav-dashboard-link" className={linkCls(loc.pathname === "/dashboard")}>
            <LayoutDashboard className="w-4 h-4" /> <span className="hidden sm:inline">Dashboard</span>
          </Link>
          {user?.role !== "student" && (
            <Link to="/generator" data-testid="nav-generator-link" className={linkCls(loc.pathname === "/generator")}>
              <Sparkles className="w-4 h-4" /> <span className="hidden sm:inline">New Lesson</span>
            </Link>
          )}

          <DropdownMenu>
            <DropdownMenuTrigger data-testid="nav-user-profile-menu" className="ml-1 outline-none">
              <Avatar className="w-9 h-9 border-2 border-primary/20">
                <AvatarFallback className="bg-primary/10 text-primary font-bold text-sm">{initials}</AvatarFallback>
              </Avatar>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-52">
              <DropdownMenuLabel>
                <div className="font-semibold">{user?.name}</div>
                <div className="text-xs text-muted-foreground font-normal">{user?.school || user?.email}</div>
              </DropdownMenuLabel>
              <DropdownMenuSeparator />
              <DropdownMenuItem
                data-testid="nav-logout-btn"
                onClick={() => {
                  logout();
                  nav("/login");
                }}
                className="text-destructive focus:text-destructive"
              >
                <LogOut className="w-4 h-4 mr-2" /> Sign out
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </nav>
      </div>
    </header>
  );
}
